import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { ThirdPartyModule } from '../../../third-party/third-party.module';
import { NewAppsSmallcardComponent } from './small-card/new-apps-smc/new-apps-smc.component';
import { SubmitProcSmallcardComponent } from './small-card/submit-proc-smc/submit-proc-smc.component';
import { SubmitUwSmallcardComponent } from './small-card/submit-uw-smc/submit-uw-smc.component';
import { FundedByPurposeLargeCardComponent } from './large-card/funded-by-purpose-lgc/funded-by-purpose-lgc.component';
import { FundedByLoanTypeLargecardComponent } from './large-card/funded-by-loan-type-lgc/funded-by-loan-type-lgc.component';
import { SoldToInvestorLargecardComponent } from './large-card/sold-to-investor-lgc/sold-to-investor-lgc.component';
import { FallOutLargecardComponent } from './large-card/fall-out-lgc/fall-out-lgc.component';
import { NewLocksSmallcardComponent } from './small-card/new-locks-smc/new-locks-smc.component';
import { ExpiresInXDaysSmallcardComponent } from './small-card/expires-in-x-days-smc/expires-in-x-days-smc.component';
import { ExpiredLocksSmallcardComponent } from './small-card/expired-locks-smc/expired-locks-smc.component';
import { PipelineByLockStatusSimpletablecardComponent } from './simple-table-card/pipeline-by-lock-status-stc/pipeline-by-lock-status-stc.component';
import { PipelineByLoanTypeSimpletablecardComponent } from './simple-table-card/pipeline-by-loan-type-stc/pipeline-by-loan-type-stc.component';
import { NewApplicationsPerPeriodLargecardComponent } from './large-card/new-applications-lgc/new-applications-lgc.component';
import { NewLocksLargecardComponent } from './large-card/new-locks-lgc/new-locks-lgc.component';
import { LockedPipelineLargecardComponent } from './large-card/locked-pipeline-lgc/locked-pipeline-lgc.component';
import { TotalPipelineLargecardComponent } from './large-card/total-pipeline-lgc/total-pipeline-lgc.component';
import { PurchasesSmallcardComponent } from './small-card/purchases-smc/purchases-smc.component';
import { GovernmentSmallcardComponent } from './small-card/government-smc/government-smc.component';
import { LockPullThruSmallcardComponent } from './small-card/lock-pull-thru-smc/lock-pull-thru-smc.component';
import { FundedPerLOSmallcardComponent } from './small-card/funded-per-lo-smc/funded-per-lo-smc.component';
import { FundedByProcSmallcardComponent } from './small-card/funded-by-proc-smc/funded-by-proc-smc.component';
import { AppToFundSmallcardComponent } from './small-card/app-to-fund-smc/app-to-fund-smc.component';
import { TotalLeadsSmdcComponent } from './small-md-card/total-leads-smdc/total-leads-smdc.component';
import { AppFromLeadsSmdcComponent } from './small-md-card/app-from-leads-smdc/app-from-leads-smdc.component';
import { LeadToAppConvSmdcComponent } from './small-md-card/lead-to-app-conv-smdc/lead-to-app-conv-smdc.component';
import { LeadToFundConvSmdcComponent } from './small-md-card/lead-to-fund-conv-smdc/lead-to-fund-conv-smdc.component';
import { FundedFromLeadesSmdcComponent } from './small-md-card/funded-from-leades-smdc/funded-from-leades-smdc.component';
import { TopLeadSourcesLgcComponent } from './large-card/top-lead-sources-lgc/top-lead-sources-lgc.component';
import { TopRealEstateAgencyLgcComponent } from './large-card/top-real-estate-agency-lgc/top-real-estate-agency-lgc.component';
import { SalesFunnelLgcComponent } from './large-card/sales-funnel-lgc/sales-funnel-lgc.component';
import { SalesPipelineLgcComponent } from './large-card/sales-pipeline-lgc/sales-pipeline-lgc.component';
import { OpsProcessorStatusLgcComponent } from './large-card/ops-processor-status-lgc/ops-processor-status-lgc.component';
import { OpsUnderwriterStatusLgcComponent } from './large-card/ops-underwriter-status-lgc/ops-underwriter-status-lgc.component';
import { OpsCloserStatusLgcComponent } from './large-card/ops-closer-status-lgc/ops-closer-status-lgc.component';
import { OpsProcessorAssignmentsLgcComponent } from './large-card/ops-processor-assignments-lgc/ops-processor-assignments-lgc.component';
import { OpsCloserAssignmentsLgcComponent } from './large-card/ops-closer-assignments-lgc/ops-closer-assignments-lgc.component';
import { OpsUnderwriterAssignmentsLgcComponent } from './large-card/ops-underwriter-assignments-lgc/ops-underwriter-assignments-lgc.component';
import { PipelineLockStatusByMilestoneLgcComponent } from './large-card/pipeline-lock-status-by-milestone-lgc/pipeline-lock-status-by-milestone-lgc.component';
import { PipelineLockStatusByLoanTypeLgcComponent } from './large-card/pipeline-lock-status-by-loan-type-lgc/pipeline-lock-status-by-loan-type-lgc.component';
import { PipelineLockExpiringLgcComponent } from './large-card/pipeline-lock-expiring-lgc/pipeline-lock-expiring-lgc.component';
import { SalesPipelineVolumeFunnelLgcComponent } from './large-card/sales-pipeline-volume-funnel-lgc/sales-pipeline-volume-funnel-lgc.component';
import { SalesPipelineVolumeTableLgcComponent } from './large-card/sales-pipeline-volume-table-lgc/sales-pipeline-volume-table-lgc.component';
import { HistoricalTrendsCreditReportsLgcComponent } from './large-card/historical-trends-credit-reports-lgc/historical-trends-credit-reports-lgc.component';
import { LoanCharacterLoanTypeSmdcComponent } from './small-md-card/loan-character-loan-type-smdc/loan-character-loan-type-smdc.component';
import { LoanCharacterLoanPurposeSmdcComponent } from './small-md-card/loan-character-loan-purpose-smdc/loan-character-loan-purpose-smdc.component';
import { LoanCharacterRefiTypeSmdcComponent } from './small-md-card/loan-character-refi-type-smdc/loan-character-refi-type-smdc.component';
import { LoanCharacterPropertyTypeSmdcComponent } from './small-md-card/loan-character-property-type-smdc/loan-character-property-type-smdc.component';
import { LoanCharacterOccupanTypeSmdcComponent } from './small-md-card/loan-character-occupan-type-smdc/loan-character-occupan-type-smdc.component';
import { LoanCharacterAmortTypeSmdcComponent } from './small-md-card/loan-character-amort-type-smdc/loan-character-amort-type-smdc.component';
import { LoanCharacterLoanToValueLgcComponent } from './large-card/loan-character-loan-to-value-lgc/loan-character-loan-to-value-lgc.component';
import { LoanCharacterInterestRateLgcComponent } from './large-card/loan-character-interest-rate-lgc/loan-character-interest-rate-lgc.component';
import { LoanCharacterLoanAmountLgcComponent } from './large-card/loan-character-loan-amount-lgc/loan-character-loan-amount-lgc.component';
import { LoanCharacterChannelLgcComponent } from './large-card/loan-character-channel-lgc/loan-character-channel-lgc.component';
import { HeadcountTrendsLgcComponent } from './large-card/headcount-trends-lgc/headcount-trends-lgc.component';
import { HistoricalTrendsFundedLgcComponent } from './large-card/historical-trends-funded-lgc/historical-trends-funded-lgc.component';
import { HistoricalTrendsLocksLgcComponent } from './large-card/historical-trends-locks-lgc/historical-trends-locks-lgc.component';
import { HistoricalTrendsApplicationsLgcComponent } from './large-card/historical-trends-applications-lgc/historical-trends-applications-lgc.component';
import { HistoricalTrendsStreamgraphLgcComponent } from './large-card/historical-trends-streamgraph-lgc/historical-trends-streamgraph-lgc.component';
import { BorrowCharacterDocTypeSmdcComponent } from './small-md-card/borrow-character-doc-type-smdc/borrow-character-doc-type-smdc.component';
import { BorrowCharacterSelfEmplSmdcComponent } from './small-md-card/borrow-character-self-empl-smdc/borrow-character-self-empl-smdc.component';
import { BorrowCharacterFicoLgcComponent } from './large-card/borrow-character-fico-lgc/borrow-character-fico-lgc.component';
import { BorrowCharacterMonthReserveLgcComponent } from './large-card/borrow-character-month-reserve-lgc/borrow-character-month-reserve-lgc.component';
import { BorrowCharacterDtiLgcComponent } from './large-card/borrow-character-dti-lgc/borrow-character-dti-lgc.component';
import { BorrowCharacterHtiLgcComponent } from './large-card/borrow-character-hti-lgc/borrow-character-hti-lgc.component';
import { PipelineOpsDisclosureLgcComponent } from './large-card/pipeline-ops-disclosure-lgc/pipeline-ops-disclosure-lgc.component';
import { PipelineOpsExpiresLgcComponent } from './large-card/pipeline-ops-expires-lgc/pipeline-ops-expires-lgc.component';
import { PipelineOpsActiveLgcComponent } from './large-card/pipeline-ops-active-lgc/pipeline-ops-active-lgc.component';
import { PipelineOpsEstNotCtcSmcComponent } from './small-card/pipeline-ops-est-not-ctc-smc/pipeline-ops-est-not-ctc-smc.component';
import { PipelineOpsLenderCreditsSmcComponent } from './small-card/pipeline-ops-lender-credits-smc/pipeline-ops-lender-credits-smc.component';
import { PipelineOpsToleranceCuresSmcComponent } from './small-card/pipeline-ops-tolerance-cures-smc/pipeline-ops-tolerance-cures-smc.component';
import { PerformanceTotalHeadcountSmcComponent } from './small-card/performance-total-headcount-smc/performance-total-headcount-smc.component';
import { PerformanceTopProducerSmcComponent } from './small-card/performance-top-producer-smc/performance-top-producer-smc.component';
import { PerformanceTotalOpsSupportSmcComponent } from './small-card/performance-total-ops-support-smc/performance-total-ops-support-smc.component';
import { PerformanceTotalProducersSmcComponent } from './small-card/performance-total-producers-smc/performance-total-producers-smc.component';
import { PerformanceTenuredProducersSmcComponent } from './small-card/performance-tenured-producers-smc/performance-tenured-producers-smc.component';
import { PerformanceProjectionsActualLgcComponent } from './large-card/performance-projections-actual-lgc/performance-projections-actual-lgc.component';
import { PerformanceKpiLgcComponent } from './large-card/performance-kpi-lgc/performance-kpi-lgc.component';
import { ProdLoanCharacterPropertyTypeSmdcComponent } from './small-md-card/prod-loan-character-property-type-smdc/prod-loan-character-property-type-smdc.component';
import { ProdLoanCharacterLoanTypeSmdcComponent } from './small-md-card/prod-loan-character-loan-type-smdc/prod-loan-character-loan-type-smdc.component';
import { ProdLoanCharacterOccupancyTypeSmdcComponent } from './small-md-card/prod-loan-character-occupancy-type-smdc/prod-loan-character-occupancy-type-smdc.component';
import { ProdLoanCharacterAmortTypeSmdcComponent } from './small-md-card/prod-loan-character-amort-type-smdc/prod-loan-character-amort-type-smdc.component';
import { ProdLoanCharacterRefiTypeSmdcComponent } from './small-md-card/prod-loan-character-refi-type-smdc/prod-loan-character-refi-type-smdc.component';
import { ProdLoanCharacterLoanPurposeSmdcComponent } from './small-md-card/prod-loan-character-loan-purpose-smdc/prod-loan-character-loan-purpose-smdc.component';
import { ProdLoanCharacterLoanAmountLgcComponent } from './large-card/prod-loan-character-loan-amount-lgc/prod-loan-character-loan-amount-lgc.component';
import { ProdLoanCharacterChannelLgcComponent } from './large-card/prod-loan-character-channel-lgc/prod-loan-character-channel-lgc.component';
import { ProdLoanCharacterLtvLgcComponent } from './large-card/prod-loan-character-ltv-lgc/prod-loan-character-ltv-lgc.component';
import { ProdLoanCharacterInterestRtLgcComponent } from './large-card/prod-loan-character-interest-rt-lgc/prod-loan-character-interest-rt-lgc.component';
import { ProdBorroCharactFicoLgcComponent } from './large-card/prod-borro-charact-fico-lgc/prod-borro-charact-fico-lgc.component';
import { ProdBorroCharactMosReservesLgcComponent } from './large-card/prod-borro-charact-mos-reserves-lgc/prod-borro-charact-mos-reserves-lgc.component';
import { ProdBorroCharactHtiLgcComponent } from './large-card/prod-borro-charact-hti-lgc/prod-borro-charact-hti-lgc.component';
import { ProdBorroCharactDtiLgcComponent } from './large-card/prod-borro-charact-dti-lgc/prod-borro-charact-dti-lgc.component';
import { ProdBorroCharactDocTypeSmdcComponent } from './small-md-card/prod-borro-charact-doc-type-smdc/prod-borro-charact-doc-type-smdc.component';
import { ProdBorroCharactSelfEmplSmdcComponent } from './small-md-card/prod-borro-charact-self-empl-smdc/prod-borro-charact-self-empl-smdc.component';
import { EstEcloseSavingsLgcComponent } from './large-card/est-eclose-savings-lgc/est-eclose-savings-lgc.component';
import { EstSavingsByMethodLgcComponent } from './large-card/est-savings-by-method-lgc/est-savings-by-method-lgc.component';
import { AvgCostSavingEloseLgcComponent } from './large-card/avg-cost-saving-elose-lgc/avg-cost-saving-elose-lgc.component';
import { EClosingMethodsTrendsLgcComponent } from './large-card/e-closing-methods-trends-lgc/e-closing-methods-trends-lgc.component';
import { ECloseFundingsSmcComponent } from './small-card/e-close-fundings-smc/e-close-fundings-smc.component';
import { ECloseVolumeSmcComponent } from './small-card/e-close-volume-smc/e-close-volume-smc.component';
import { EClosingMixLgcComponent } from './large-card/e-closing-mix-lgc/e-closing-mix-lgc.component';

export class StandaloneComponentsCollection {
    standaloneComponents = {
        'new-apps': NewAppsSmallcardComponent,
        expiring: ExpiresInXDaysSmallcardComponent,
        'expired-locks': ExpiredLocksSmallcardComponent,
        'new-locks': NewLocksSmallcardComponent,
        'submit-uw': SubmitUwSmallcardComponent,
        'submit-proc': SubmitProcSmallcardComponent,
        'funded-by-loan-type': FundedByLoanTypeLargecardComponent,
        'sold-to-investor': SoldToInvestorLargecardComponent,
        'funded-by-purpose': FundedByPurposeLargeCardComponent,
        'fall-out': FallOutLargecardComponent,
        insights_pipelineByLoanStatus: PipelineByLockStatusSimpletablecardComponent,
        insights_pipelineByLoanType: PipelineByLoanTypeSimpletablecardComponent,
        'new-applications-per-period': NewApplicationsPerPeriodLargecardComponent,
        'new-locks-per-period': NewLocksLargecardComponent,
        'locked-pipeline': LockedPipelineLargecardComponent,
        'total-pipeline': TotalPipelineLargecardComponent,
        purchases: PurchasesSmallcardComponent,
        government: GovernmentSmallcardComponent,
        lockPullThru: LockPullThruSmallcardComponent,
        fundedPerLO: FundedPerLOSmallcardComponent,
        fundedByProc: FundedByProcSmallcardComponent,
        appToFund: AppToFundSmallcardComponent,
        totalLeads: TotalLeadsSmdcComponent,
        applicationsFromLeads: AppFromLeadsSmdcComponent,
        leadToAppConversion: LeadToAppConvSmdcComponent,
        leadToFundConversion: LeadToFundConvSmdcComponent,
        fundedFromLeads: FundedFromLeadesSmdcComponent,
        leadSources: TopLeadSourcesLgcComponent,
        realEstateBuyerAgents: TopRealEstateAgencyLgcComponent,
        pipeline_sales_funnel: SalesFunnelLgcComponent,
        pipeline_sales: SalesPipelineLgcComponent,
        'ops-processor-status': OpsProcessorStatusLgcComponent,
        'ops-underwriter-status': OpsUnderwriterStatusLgcComponent,
        'ops-closer-status': OpsCloserStatusLgcComponent,
        'ops-processor-assignments': OpsProcessorAssignmentsLgcComponent,
        'ops-closer-assignments': OpsCloserAssignmentsLgcComponent,
        'ops-underwriter-assignments': OpsUnderwriterAssignmentsLgcComponent,
        insights_lockStatusByMilestone: PipelineLockStatusByMilestoneLgcComponent,
        insights_lockStatusByLoanType: PipelineLockStatusByLoanTypeLgcComponent,
        insights_locksExpiringInDays: PipelineLockExpiringLgcComponent,
        'sales-pipeline-volume-funnel': SalesPipelineVolumeFunnelLgcComponent,
        'sales-pipeline-volume-table': SalesPipelineVolumeTableLgcComponent,
        'historical-trends-credit-reports': HistoricalTrendsCreditReportsLgcComponent,
        'historical-trends-applications': HistoricalTrendsApplicationsLgcComponent,
        'historical-trends-locked': HistoricalTrendsLocksLgcComponent,
        'historical-trends-funded': HistoricalTrendsFundedLgcComponent,
        'loan-character-loan-type': LoanCharacterLoanTypeSmdcComponent,
        'loan-character-loan-purpose': LoanCharacterLoanPurposeSmdcComponent,
        'loan-character-refi-type': LoanCharacterRefiTypeSmdcComponent,
        'loan-character-property-type': LoanCharacterPropertyTypeSmdcComponent,
        'loan-character-occupan-type': LoanCharacterOccupanTypeSmdcComponent,
        'loan-character-amort-type': LoanCharacterAmortTypeSmdcComponent,
        'loan-character-loan-to-value': LoanCharacterLoanToValueLgcComponent,
        'loan-character-interest-rate': LoanCharacterInterestRateLgcComponent,
        'loan-character-loan-amount': LoanCharacterLoanAmountLgcComponent,
        'loan-character-channel': LoanCharacterChannelLgcComponent,
        'historical-trends-streamgraph': HistoricalTrendsStreamgraphLgcComponent,
        'historical-trends-headcount-trends': HeadcountTrendsLgcComponent,
        'borrower-characteristics-doc-type': BorrowCharacterDocTypeSmdcComponent,
        'borrower-characteristics-self-employed': BorrowCharacterSelfEmplSmdcComponent,
        'borrower-characteristics-fico': BorrowCharacterFicoLgcComponent,
        'borrower-characteristics-months-reserves': BorrowCharacterMonthReserveLgcComponent,
        'borrower-characteristics-debt-to-income': BorrowCharacterDtiLgcComponent,
        'borrower-characteristics-housing-to-income': BorrowCharacterHtiLgcComponent,
        'pipeline-ops-disclosure': PipelineOpsDisclosureLgcComponent,
        'pipeline-ops-expires-7days': PipelineOpsExpiresLgcComponent,
        'pipeline-ops-active-pipeline': PipelineOpsActiveLgcComponent,
        'pipeline-ops-estimated-not-ctc': PipelineOpsEstNotCtcSmcComponent,
        'pipeline-ops-lender-credits': PipelineOpsLenderCreditsSmcComponent,
        'pipeline-ops-tolerance-cures': PipelineOpsToleranceCuresSmcComponent,
        totalHeadcount: PerformanceTotalHeadcountSmcComponent,
        topProducersByscore: PerformanceTopProducerSmcComponent,
        totalOpsSupport: PerformanceTotalOpsSupportSmcComponent,
        totalProducers: PerformanceTotalProducersSmcComponent,
        bottomTenuredProducers: PerformanceTenuredProducersSmcComponent,
        'performance-projections-actual': PerformanceProjectionsActualLgcComponent,
        'performance-kpi': PerformanceKpiLgcComponent,
        'prod-loan-character-property-type': ProdLoanCharacterPropertyTypeSmdcComponent,
        'prod-loan-character-loan-type': ProdLoanCharacterLoanTypeSmdcComponent,
        'prod-loan-character-occupan-type': ProdLoanCharacterOccupancyTypeSmdcComponent,
        'prod-loan-character-amort-type': ProdLoanCharacterAmortTypeSmdcComponent,
        'prod-loan-character-refi-type': ProdLoanCharacterRefiTypeSmdcComponent,
        'prod-loan-character-loan-purpose': ProdLoanCharacterLoanPurposeSmdcComponent,
        'prod-loan-character-loan-amount': ProdLoanCharacterLoanAmountLgcComponent,
        'prod-loan-character-channel': ProdLoanCharacterChannelLgcComponent,
        'prod-loan-character-loan-to-value': ProdLoanCharacterLtvLgcComponent,
        'prod-loan-character-interest-rate': ProdLoanCharacterInterestRtLgcComponent,
        'prod-borrower-characteristics-fico': ProdBorroCharactFicoLgcComponent,
        'prod-borrower-characteristics-months-reserves': ProdBorroCharactMosReservesLgcComponent,
        'prod-borrower-characteristics-housing-to-income': ProdBorroCharactHtiLgcComponent,
        'prod-borrower-characteristics-debt-to-income': ProdBorroCharactDtiLgcComponent,
        'prod-borrower-characteristics-doc-type': ProdBorroCharactDocTypeSmdcComponent,
        'prod-borrower-characteristics-self-employed': ProdBorroCharactSelfEmplSmdcComponent,
        insights_estimatedECloseSaving: EstEcloseSavingsLgcComponent,
        insights_estimatedSavingByECloseMethod: EstSavingsByMethodLgcComponent,
        insights_averageCostSavingPerLoan: AvgCostSavingEloseLgcComponent,
        eClosingMethodTrends: EClosingMethodsTrendsLgcComponent,
        eClosingMix: EClosingMixLgcComponent,
        eCloseFundings: ECloseFundingsSmcComponent,
        eCloseVolume: ECloseVolumeSmcComponent,
    };

    getComponent(componentId: string) {
        return this.standaloneComponents[componentId];
    }

    getAllComponentsArray() {
        return Object.values(this.standaloneComponents);
    }
}

const moduleList: Array<any> = new StandaloneComponentsCollection().getAllComponentsArray();

//export class testModule {
//    static withComponents(components: any[]) {
//        return {
//            ngModule: testModule,
//            providers: [
//                { provide: ANALYZE_FOR_ENTRY_COMPONENTS, useValue: components, multi: true }
//            ]
//        }
//    }
//}

@NgModule({
    //declarations: [moduleList],
    // TODO: get these components dynamically
    declarations: [
        NewAppsSmallcardComponent,
        SubmitProcSmallcardComponent,
        SubmitUwSmallcardComponent,
        FundedByPurposeLargeCardComponent,
        FundedByLoanTypeLargecardComponent,
        SoldToInvestorLargecardComponent,
        FallOutLargecardComponent,
        SubmitProcSmallcardComponent,
        NewLocksSmallcardComponent,
        ExpiresInXDaysSmallcardComponent,
        ExpiredLocksSmallcardComponent,
        PipelineByLockStatusSimpletablecardComponent,
        PipelineByLoanTypeSimpletablecardComponent,
        NewApplicationsPerPeriodLargecardComponent,
        NewLocksLargecardComponent,
        LockedPipelineLargecardComponent,
        TotalPipelineLargecardComponent,
        PurchasesSmallcardComponent,
        GovernmentSmallcardComponent,
        LockPullThruSmallcardComponent,
        FundedPerLOSmallcardComponent,
        FundedByProcSmallcardComponent,
        AppToFundSmallcardComponent,
        TotalLeadsSmdcComponent,
        AppFromLeadsSmdcComponent,
        LeadToAppConvSmdcComponent,
        LeadToFundConvSmdcComponent,
        FundedFromLeadesSmdcComponent,
        TopLeadSourcesLgcComponent,
        TopRealEstateAgencyLgcComponent,
        SalesFunnelLgcComponent,
        SalesPipelineLgcComponent,
        OpsProcessorStatusLgcComponent,
        OpsUnderwriterStatusLgcComponent,
        OpsCloserStatusLgcComponent,
        OpsProcessorAssignmentsLgcComponent,
        OpsCloserAssignmentsLgcComponent,
        OpsUnderwriterAssignmentsLgcComponent,
        PipelineLockStatusByMilestoneLgcComponent,
        PipelineLockStatusByLoanTypeLgcComponent,
        PipelineLockExpiringLgcComponent,
        SalesPipelineVolumeFunnelLgcComponent,
        SalesPipelineVolumeTableLgcComponent,
        HistoricalTrendsCreditReportsLgcComponent,
        LoanCharacterLoanTypeSmdcComponent,
        LoanCharacterLoanPurposeSmdcComponent,
        LoanCharacterRefiTypeSmdcComponent,
        LoanCharacterPropertyTypeSmdcComponent,
        LoanCharacterOccupanTypeSmdcComponent,
        LoanCharacterAmortTypeSmdcComponent,
        LoanCharacterLoanToValueLgcComponent,
        LoanCharacterInterestRateLgcComponent,
        LoanCharacterLoanAmountLgcComponent,
        LoanCharacterChannelLgcComponent,
        HeadcountTrendsLgcComponent,
        HistoricalTrendsFundedLgcComponent,
        HistoricalTrendsLocksLgcComponent,
        HistoricalTrendsApplicationsLgcComponent,
        HistoricalTrendsStreamgraphLgcComponent,
        BorrowCharacterDocTypeSmdcComponent,
        BorrowCharacterSelfEmplSmdcComponent,
        BorrowCharacterFicoLgcComponent,
        BorrowCharacterMonthReserveLgcComponent,
        BorrowCharacterDtiLgcComponent,
        BorrowCharacterHtiLgcComponent,
        PipelineOpsDisclosureLgcComponent,
        PipelineOpsExpiresLgcComponent,
        PipelineOpsActiveLgcComponent,
        PipelineOpsEstNotCtcSmcComponent,
        PipelineOpsLenderCreditsSmcComponent,
        PipelineOpsToleranceCuresSmcComponent,
        PerformanceTotalHeadcountSmcComponent,
        PerformanceTopProducerSmcComponent,
        PerformanceTotalOpsSupportSmcComponent,
        PerformanceTotalProducersSmcComponent,
        PerformanceTenuredProducersSmcComponent,
        PerformanceProjectionsActualLgcComponent,
        PerformanceKpiLgcComponent,
        ProdLoanCharacterPropertyTypeSmdcComponent,
        ProdLoanCharacterLoanTypeSmdcComponent,
        ProdLoanCharacterOccupancyTypeSmdcComponent,
        ProdLoanCharacterAmortTypeSmdcComponent,
        ProdLoanCharacterRefiTypeSmdcComponent,
        ProdLoanCharacterLoanPurposeSmdcComponent,
        ProdLoanCharacterLoanAmountLgcComponent,
        ProdLoanCharacterChannelLgcComponent,
        ProdLoanCharacterLtvLgcComponent,
        ProdLoanCharacterInterestRtLgcComponent,
        ProdBorroCharactFicoLgcComponent,
        ProdBorroCharactMosReservesLgcComponent,
        ProdBorroCharactHtiLgcComponent,
        ProdBorroCharactDtiLgcComponent,
        ProdBorroCharactDocTypeSmdcComponent,
        ProdBorroCharactSelfEmplSmdcComponent,
        EstEcloseSavingsLgcComponent,
        EstSavingsByMethodLgcComponent,
        AvgCostSavingEloseLgcComponent,
        EClosingMethodsTrendsLgcComponent,
        ECloseFundingsSmcComponent,
        ECloseVolumeSmcComponent,
        EClosingMixLgcComponent,
    ],
    imports: [CommonModule, SharedModule, ThirdPartyModule],
    exports: [],
    providers: [],
    schemas: [NO_ERRORS_SCHEMA],
})
export class StandaloneComponentsModule {}
